import { Link } from "@mui/material";
import { useInteractionsStore } from "@hooks/useInteractionsStore";
import {
  Container,
  AlertComponent,
  AlertContainer,
} from "../styles/InteractionAlertCard.styles";
import { InteractionAlert } from "@interfaces/Interactions";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { tracker } from "@utils/openreplay";

export function InteractionAlertCard() {
  const { requestId = "" } = useParams();
  const {
    interactions: interactionsData,
    hasTrackedEvent,
    setHasTrackedEvent,
  } = useInteractionsStore(requestId);

  useEffect(() => {
    const count = interactionsData?.length ?? 0;
    if (hasTrackedEvent || count === 0) return;

    tracker?.event("MekiDocPRO", {
      requestId,
      source: "InteractionAlertCard",
    });
    setHasTrackedEvent(true);
  }, [interactionsData, hasTrackedEvent, setHasTrackedEvent, requestId]);

  const interactionAlerts: InteractionAlert[] = interactionsData.map(
    (interaction, index) => ({
      drug1: interaction.drug_1_names.es,
      drug2: interaction.drug_2_names.es,
      summary: interaction.description.summary.es,
      url: interaction.source_url,
      id: `interaction-${index}-${interaction.source}`,
    })
  );

  const getInteractionText = useCallback((interaction: InteractionAlert) => {
    const drug1Capitalized =
      interaction.drug1.charAt(0).toUpperCase() + interaction.drug1.slice(1);
    const drug2Capitalized =
      interaction.drug2.charAt(0).toUpperCase() + interaction.drug2.slice(1);
    const summaryText = interaction.summary.split(" ").slice(3).join(" ");
    const summaryFormatted = summaryText.endsWith(".")
      ? summaryText
      : summaryText + ". ";
    return (
      <>
        <b style={{ fontWeight: 600 }}>
          {drug1Capitalized} con {drug2Capitalized}
        </b>{" "}
        {summaryFormatted}
        <Link
          href={interaction.url}
          target="_blank"
          color="#006BD6"
          rel="noopener noreferrer"
        >
          Ver más detalle
        </Link>
      </>
    );
  }, []);

  if (!interactionsData || interactionsData.length === 0) {
    return null;
  }

  return (
    <Container>
      {interactionAlerts.map((interaction) => (
        <AlertContainer key={interaction.id}>
          <AlertComponent severity="warning">
            {getInteractionText(interaction)}
          </AlertComponent>
        </AlertContainer>
      ))}
    </Container>
  );
}
